import React from "react";
import {
  ActionButton,
  ActionButtons,
  dialogStore,
  Footer,
  SectionPlaceholder,
} from "@ucl/library";
import {
  defaultRegistry,
  TaskExecutionModuleRegistry,
} from "../TaskExecutionModule/registry";
import {
  TaskExecutionModuleFormRegistry,
  TaskExecutionModuleProps,
} from "../TaskExecutionModule/TaskExecutionModuleProps";
import { BoltTaskStatuses, TaskExecutionTypeFieldSchema } from "@bolt/core";
import { TaskExecutionWithdrawComponent } from "./TaskExecutionWithdrawComponent";
import { parseUntrustedHtml } from "@ucl/library";

export interface TaskExecutionLoaderProps {
  taskDetail: string;
  taskTemplateDescription?: string;
  taskStatus: BoltTaskStatuses;
  taskExecutionType: string;
  taskExecutionTypeFields: TaskExecutionTypeFieldSchema;
  onWithdraw: (reason: string) => Promise<void>;
  onReinstate: () => Promise<void>;
  customRegistry?: TaskExecutionModuleRegistry;
  onTaskComplete?: (
    updatedTaskExecutionTypeFields: TaskExecutionTypeFieldSchema
  ) => Promise<void>;
  apiBaseUrl?: string;
  getAuthRequestHeader?: () => Promise<Record<string, string> | undefined>;
  withdrawLabel?: string;
  formRegistry?: TaskExecutionModuleFormRegistry;
  entityId?: string;
  entityType?: string;
  parentEntityId?: string;
  parentEntityType?: string;
}

export const TaskExecutionLoader: React.FC<TaskExecutionLoaderProps> = (
  props
) => {
  // const [fieldsSubmittedData, setFieldsSubmittedData] = useState<
  //   Record<string, any>
  // >({});
  // const [fieldsErrors] = useState<Record<string, string[]>>({});
  // const boltApiClient = useBoltApiClient();
  // const { getAsyncSchemaFactory } = useFieldSchemaV2("tasks/field-schema");
  // const [schemaFactory, setSchemaFactory] = useState<SchemaFactoryV2>();
  // const loadingRef = useRef<boolean>(false);

  // const getSchema = async () => {
  //   if (loadingRef.current) return;
  //   loadingRef.current = true;
  //   setSchemaFactory(await getAsyncSchemaFactory(boltApiClient));
  // };

  // useEffect(() => {
  //   getSchema();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // if (!schemaFactory) {
  //   return <div className="task-execution-loader">Loading schema...</div>;
  // }

  // // Compose the value for TaskExecutionTypeComponent
  // const complexFieldValue = {
  //   factory: schemaFactory,
  //   getAuthRequestHeader: props.getAuthRequestHeader || (async () => ({})),
  //   apiBaseUrl: props.apiBaseUrl || "",
  //   errors: {}, // TODO: Add errors
  // };

  // const handleFieldsSubmit = async (_updated: Record<string, any>) => {
  //   // TODO Validate. Need to think this more.
  //   // If errors reset fieldsSubmittedData, otherwise save them on the task. Will be up to the module to fetch them on their Submit.
  //   // setFieldsErrors
  //   //setFieldsSubmittedData(updated);
  // };

  const handleTaskComplete = async (
    updatedTaskExecutionTypeFields: TaskExecutionTypeFieldSchema
  ) => {
    // Todo
    // TODO Save the fieldsSubmittedData
    // TODO Call the onTaskComplete
    if (props.onTaskComplete) {
      await props.onTaskComplete(updatedTaskExecutionTypeFields);
    }
  };

  // Load the module based on the taskExecutionType
  if (!props.taskExecutionType) {
    console.error(`Task execution type is not defined in TaskExecutionLoader`);
    return <SectionPlaceholder label="Task could not be loaded" />;
  }

  // Merge Registries
  const registry = {
    ...defaultRegistry,
    ...props.customRegistry,
  };

  const ModuleComponent = registry?.[props.taskExecutionType] as React.FC<
    Partial<TaskExecutionModuleProps>
  >;

  if (!ModuleComponent) {
    console.error(
      `Task execution type ${props.taskExecutionType} is not defined in registry`
    );

    return <SectionPlaceholder label="Task could not be loaded" />;
  }

  return (
    <section className="task-execution-loader">
      {/* <GeneralTaskExecutionTypeModule onTaskComplete={handleTaskComplete} /> */}
      {/* Load the module based on the taskExecutionType */}
      <div className="task-execution-module">
        <div className="task-execution-module-container">
          {props.taskTemplateDescription && (
            <>
              <h3>Task Description</h3>
              {parseUntrustedHtml(props.taskTemplateDescription)}
            </>
          )}
          {props.taskDetail && props.taskTemplateDescription !== props.taskDetail && (
            <>
              <h3>Task Details</h3>
              {parseUntrustedHtml(props.taskDetail)}
            </>
          )}
          <ModuleComponent
            isReadOnly={
              props.taskStatus === BoltTaskStatuses.Completed ||
              props.taskStatus === BoltTaskStatuses.Withdrawn
            }
            taskExecutionType={props.taskExecutionType}
            taskExecutionTypeFields={props.taskExecutionTypeFields}
            apiBaseUrl={props.apiBaseUrl}
            getAuthRequestHeader={props.getAuthRequestHeader}
            onTaskComplete={handleTaskComplete}
            formRegistry={props.formRegistry}
            entityId={props.entityId}
            entityType={props.entityType}
            parentEntityId={props.parentEntityId}
            parentEntityType={props.parentEntityType}
          />
        </div>
      </div>
      {/* {props.taskExecutionTypeFields && (
        <TaskExecutionFieldsLoader
          apiBaseUrl={props.apiBaseUrl}
          getAuthRequestHeader={props.getAuthRequestHeader}
          taskExecutionTypeFields={props.taskExecutionTypeFields}
          onSubmit={handleFieldsSubmit}
          errors={fieldsErrors}
        />
      )} */}
      <Footer className="task-execution-loader-footer">
        <ActionButtons
          actions={[
            // Show Withdraw only if taskstatus === "In Progress"
            ...(props.taskStatus === BoltTaskStatuses.InProgress ||
            props.taskStatus === BoltTaskStatuses.New
              ? [
                  {
                    text: props.withdrawLabel || "Withdraw",
                    isPrimary: false,
                    position: "left",
                    onActionClick: () => {
                      dialogStore.openDialog({
                        id: "withdraw-task-dialog",
                        header: "Withdraw Task",
                        content: () => (
                          <TaskExecutionWithdrawComponent
                            onWithdraw={async (reason) => {
                              try {
                                await props.onWithdraw(reason);
                                dialogStore.closeDialog("withdraw-task-dialog");
                              } catch (error) {
                                console.error(error);
                              }
                            }}
                            onCancel={() =>
                              dialogStore.closeDialog("withdraw-task-dialog")
                            }
                          />
                        ),
                      });
                    },
                  } as ActionButton<unknown>,
                ]
              : []),
            // Show Reinstate only if taskstatus === "Completed"
            ...(props.taskStatus === BoltTaskStatuses.Completed
              ? [
                  {
                    text: "Reinstate",
                    isPrimary: false,
                    position: "left",
                    onActionClick: () => {
                      dialogStore.openConfirmDialog({
                        dialogId: "reinstate-task-dialog",
                        content: "Are you sure you want to reinstate the task?",
                        confirmButtonText: "Reinstate",
                        // color: "forest-green",
                        onConfirm: async () => {
                          const result = {
                            isSuccess: true,
                            error: undefined,
                          };

                          await props.onReinstate().catch((error) => {
                            console.error(error);
                            result.isSuccess = false;
                            result.error = error;
                          });

                          return result;
                        },
                      });
                    },
                  } as ActionButton<unknown>,
                ]
              : []),
          ]}
        />
      </Footer>
    </section>
  );
};
